if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				// id: item.dataset.id,
				quantity: newQty,
				line: +item.dataset.line
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => {
					if ( response.ok ) {
						return fetch('?section_id=helper-cart')
					} else {
						throw new Error('Something went wrong');
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					// Check free gift eligibility after cart update
					if (typeof free_product_added === 'function') {
						free_product_added();
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			document.getElementById('site-cart-sidebar').show();

		})

	}

}
function free_product_added() {
	const FIRST_VARIANT_ID = 50894971765051;  
	const SECOND_VARIANT_ID = 50894971797819; 
	const FREE_GIFT_VARIANT_IDS = [FIRST_VARIANT_ID, SECOND_VARIANT_ID];

	setTimeout(() => {
		fetch('/cart.json')
		.then(res => res.json())
		.then(data => {
			// Calculate cart total excluding gift items (matching Liquid template logic)
			let cart_item_total = 0;
			data.items.forEach(item => {
				// Exclude items with vendor "Gift" or title containing "Free" or price 0
				const isGift = item.vendor === 'Gift' || 
							   (item.vendor && item.vendor.includes('Gift')) || 
							   (item.title && item.title.includes('Free')) ||
							   FREE_GIFT_VARIANT_IDS.includes(item.variant_id);
				if (!isGift) {
					cart_item_total += item.final_line_price;
				}
			});
			cart_item_total = cart_item_total / 100; // Convert from cents to dollars/rupees
			
			const cart_free_product = data.items.find(item => FREE_GIFT_VARIANT_IDS.includes(item.variant_id));

			if (cart_item_total >= 2500) {
				if (!cart_free_product) {
					fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							items: [{ id: FIRST_VARIANT_ID, quantity: 1 }]
						})
					})
					.then(res => res.json())
					.then(response => {
						if (response.status === 422) {
							console.log('First variant sold out, trying second variant');
							return fetch('/cart/add.js', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json' },
								body: JSON.stringify({
									items: [{ id: SECOND_VARIANT_ID, quantity: 1 }]
								})
							}).then(res => res.json());
						}
						return response;
					})
					.then(() => {
						console.log('Free gift added');
						window.refreshCart();
					});
				}
			} else {
				if (cart_free_product) {
					fetch('/cart/change.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							id: cart_free_product.key,
							quantity: 0
						})
					})
					.then(res => res.json())
					.then(() => {
						console.log('Free product removed');
						window.refreshCart();
					});
				}
			}
		});
	}, 500);
}